import { createModel } from "@rematch/core";
import { RootModel } from "app/store";
import {
  ListRequestParams,
  mergeListParams,
  mergeListParamsWithPagination,
  OrderByType,
} from "widgets/table/useTableUtils";
import { api } from "api";
import { InventoryCategoryVm } from "api/generated/lumen";
import { mapToGetAllQuery } from "utils";

interface InventoryCategoryListState {
  listParams: ListRequestParams;
  list: InventoryCategoryVm[];
}

const initialState: InventoryCategoryListState = {
  listParams: {
    pageSize: 10,
    order: [
      {
        orderBy: "name",
        orderByType: OrderByType.Ascending,
      },
    ],
  },
  list: [],
};

export const inventoryCategoryList = createModel<RootModel>()({
  state: initialState,
  reducers: {
    resetListParams(state) {
      state.listParams = {
        ...initialState.listParams,
        order: initialState.listParams.order,
      };
    },
    setList(
      state,
      {
        data,
        listParams,
      }: { data: InventoryCategoryVm[]; listParams: ListRequestParams }
    ) {
      state.list = data;
      state.listParams = listParams;
    },
    reset: () => initialState,
  },
  effects: (dispatch) => {
    const { inventoryCategoryList } = dispatch;

    return {
      async fetchList(params: ListRequestParams = {}, state): Promise<void> {
        const mergedParams = mergeListParams(
          state.inventoryCategoryList.listParams,
          params
        );

        const data = await api.lumen.inventoryCategory.apiInventoryCategoryPost(
          { getAllInventoryCategoriesQuery: mapToGetAllQuery(mergedParams) }
        );

        const { items, ...pagination } = data;

        dispatch(
          inventoryCategoryList.setList({
            data: items || [],
            listParams: mergeListParamsWithPagination(mergedParams, pagination),
          })
        );
      },
    };
  },
});
